"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TimelineDateRange = void 0;

var _TimelineStatusStore = _interopRequireDefault(require("crm_ui/timeline/data/stores/TimelineStatusStore"));

var _immutable = require("immutable");

var TimelineDateRange = (0, _immutable.Record)({
  fromDate: null,
  toDate: null
});
exports.TimelineDateRange = TimelineDateRange;
var cache = TimelineDateRange();
var TimelineSimpleDateRangeDependency = {
  stores: [_TimelineStatusStore.default],
  deref: function deref() {
    var timelineStatus = _TimelineStatusStore.default.get('timelineStatus');

    var dateRange;

    if (timelineStatus.getIn(['originalPayload', 'fromDate'])) {
      dateRange = TimelineDateRange({
        fromDate: timelineStatus.getIn(['originalPayload', 'fromDate']),
        toDate: timelineStatus.getIn(['originalPayload', 'toDate'])
      });
    } else {
      var firstDateRange = _TimelineStatusStore.default.get('firstDateRange');

      dateRange = TimelineDateRange({
        fromDate: firstDateRange.get('fromDate'),
        toDate: firstDateRange.get('toDate')
      });
    }

    if (!(0, _immutable.is)(dateRange, cache)) {
      cache = dateRange;
    }

    return cache;
  }
};
var _default = TimelineSimpleDateRangeDependency;
exports.default = _default;